import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/alipay.jpg';
const _withScopeId = n => (_pushScopeId("data-v-456a93c6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "menu"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "box"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "充值金额", -1));
const _hoisted_5 = {
  class: "card"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "选择金额", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "充值平台", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "zhifu"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})], -1));
const _hoisted_9 = {
  class: "card"
};
const _hoisted_10 = {
  class: "btn"
};
import { showFailToast } from "vant";
import { reactive, onMounted } from 'vue';
import Menu from "@/components/menu.vue";
import api from "@/api";
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const data = reactive({
      checked: '50.00',
      userId: '',
      account: '',
      pwd: '',
      money: 0
    });
    onMounted(async () => {
      var _JSON$parse, _JSON$parse2, _JSON$parse3;
      const User = window.localStorage.getItem('user');
      data.userId = (_JSON$parse = JSON.parse(User)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.id;
      data.account = (_JSON$parse2 = JSON.parse(User)) === null || _JSON$parse2 === void 0 ? void 0 : _JSON$parse2.account;
      data.pwd = (_JSON$parse3 = JSON.parse(User)) === null || _JSON$parse3 === void 0 ? void 0 : _JSON$parse3.pwd;
      if (User) {
        await api.logins(data.account, data.pwd).then(res => {
          if (res.data.code == 0) {
            data.money = res.data.data.money;
          }
        });
      }
    });
    const clikeMenu = async () => {};
    const toOrder = async () => {
      await api.order(data.userId, '成都康威网络音乐产品', data.checked, 'http://192.168.2.39:8080/#/recharge').then(res => {
        console.log(res.data);
        if (res.data.code == 0) {
          window.localStorage.setItem('orderId', res.data.data.orderid);
          window.location.href = res.data.data.data;
        } else {
          showFailToast(res.data.msg);
        }
      });
    };
    const Refresh = async () => {
      await api.logins(data.account, data.pwd).then(res => {
        if (res.data.code == 0) {
          data.money = res.data.data.money;
          alert('刷新成功');
        } else {
          showFailToast(res.data.msg);
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_van_radio = _resolveComponent("van-radio");
      const _component_van_radio_group = _resolveComponent("van-radio-group");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Menu, {
        "active-name": ""
      }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_hoisted_6, _createVNode(_component_van_radio_group, {
        modelValue: data.checked,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.checked = $event),
        onClick: clikeMenu
      }, {
        default: _withCtx(() => [_createVNode(_component_van_radio, {
          name: "50.00"
        }, {
          default: _withCtx(() => [_createTextVNode("50元")]),
          _: 1
        }), _createVNode(_component_van_radio, {
          name: "100.00"
        }, {
          default: _withCtx(() => [_createTextVNode("100元")]),
          _: 1
        }), _createVNode(_component_van_radio, {
          name: "150.00"
        }, {
          default: _withCtx(() => [_createTextVNode("150元")]),
          _: 1
        }), _createVNode(_component_van_radio, {
          name: "200.00"
        }, {
          default: _withCtx(() => [_createTextVNode("200元")]),
          _: 1
        }), _createVNode(_component_van_radio, {
          name: "500.00"
        }, {
          default: _withCtx(() => [_createTextVNode("500元")]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", {
        class: "card"
      }, [_hoisted_7, _hoisted_8, _createElementVNode("div", {
        class: "btn"
      }, [_createElementVNode("button", {
        onClick: toOrder,
        class: "order"
      }, "充值")])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("button", {
        onClick: Refresh,
        class: "order"
      }, "刷新余额"), _createElementVNode("p", null, "当前余额：" + _toDisplayString(data.money / 100) + "元", 1)])])])])]);
    };
  }
});